<template>
  <el-button
    v-if="Object.keys(printContract).length"
    type="primary"
    @click="print_contract"
  >
    {{ text }}
  </el-button>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { printConfig } from './constants'

const Contracts = RepositoryFactory.get('contractsRepository')
const Doc = RepositoryFactory.get('document')

export default {
  name: 'PrintContract',
  props: {
    contragent: {
      type: Object,
      default: () => {},
    },
    proxy: {
      type: Object,
      default: () => null,
    },
    inn: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: 'Типовой договор',
    },
    asPdf: {
      type: Boolean,
      default: false,
    },
    withSign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      printContract: {},
    }
  },
  watch: {
    contragent: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.printContract = {}

        if (newVal) {
          this.printContract.v_lice =
            this.proxy.v_lice || 'ген. директора Незамутдинова Руслана Яновича'
          this.printContract.proxy_doc_num =
            this.proxy.proxy_doc_num || 'Устава'
          this.printContract.proxy_doc_date = this.proxy.proxy_doc_date || null

          this.printContract.orgName = this.contragent.org_name
          this.printContract.address = this.contragent.address
          this.printContract.inn = this.contragent.inn
          this.printContract.ogrn = this.contragent.org.ogrn || null
          this.printContract.rs = this.contragent.checking_account
          this.printContract.bankName = this.contragent.name_bank
          this.printContract.ks = this.contragent.core_account
          this.printContract.bik = this.contragent.bik
          this.printContract.phone = this.contragent.phone
          this.printContract.email = this.contragent.email
          this.printContract.dateBegin = new Date()
            .toLocaleString('ru')
            .split(', ')[0]
          this.printContract.dateEnd = `31.12.${new Date().getFullYear()}`
          this.printContract.performer_inn = this.inn
          this.printContract.as_pdf = this.asPdf ? 1 : 0
          this.printContract.with_sign = this.withSign ? 1 : 0

          if (this.contragent.patent) {
            this.printContract.patent = this.contragent.patent
          }
        }
      },
    },
  },
  methods: {
    print_contract() {
      Contracts.docNum(this.cur_org_inn)
        .then(res => {
          let numDoc = 'Н/Д'

          if (res.data.length > 0) {
            const converNum = Number(res.data[0].number) + 1

            if (!Number.isNaN(converNum)) {
              numDoc = converNum
            }
          }
          this.renderPrompt(numDoc)
        })
        .catch(err => this.errHandler(err))
    },
    renderPrompt(numDoc) {
      this.$prompt(...printConfig(numDoc))
        .then(({ value }) => {
          this.printContract.num = value
          const path = Doc.getReportLink(
            'word-builder/template/dogovor',
            this.printContract,
          )

          this.downloadRegistry({ path })
        })
        .catch(() => {})
    },
  },
}
</script>
